import { loadScript } from '@/utils/index';

/**
 * 初始化 Google Ad Manager (GPT) SDK
 * 动态加载 GPT 脚本, 用于展示广告
 */
export const initAdManager = (): void => {
    loadScript({
        src: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
        scriptId: 'google-ad-manager',
        async: true,
        crossOrigin: 'anonymous',
    });
};
